import { useSearchParams } from 'next/navigation'
import type { z } from 'zod'

export const useParsedSearchParams = <Schema extends z.ZodTypeAny>(schema: Schema): z.infer<Schema> | null => {
  const searchParams = useSearchParams()
  const parsed = schema.safeParse(Object.fromEntries(searchParams ?? []))

  return parsed.success ? parsed.data : null
}
